export default __webpack_public_path__ + "static/location-men-c199cdb3da325e6e4293e1d073dffa05.jpg";